import { WritableSignal } from "@angular/core";

import { createNode } from "./create-node.function";
import { getFromPath } from "./set-get-path.function";
import { SignalTree } from "../types/signal-tree.type";

export function createProxy<T>(
    rootValue$$: WritableSignal<any>,
    path: string[] = []
): SignalTree<T> {

    return new Proxy(() => {}, {

        get(_, prop: string) {

            if (prop === 'set' || prop === 'update' || prop === 'delete') {
                return createNode(rootValue$$, path)[prop];
            }

            if (prop === 'ensure') {
                return (fallback: any) => {
                    const current = getFromPath(rootValue$$(), path);

                    if (current === undefined) {
                        const value =
                            typeof fallback === 'function'
                                ? fallback()
                                : structuredClone(fallback);

                        createNode(rootValue$$, path).set(value);
                    }

                    return createProxy(rootValue$$, path);
                };
            } else if (prop === 'ensureDeep') {
                return (fallback: any) => {
                    const current = getFromPath(rootValue$$(), path);
                    
                    if (typeof fallback !== 'object' || fallback === null) {
                        throw new Error('ensureDeep requires object fallback');
                    }

                    if (!current) {
                        createNode(rootValue$$, path).set(structuredClone(fallback));
                    } else {
                        createNode(rootValue$$, path).update(v => ({
                            ...(fallback as Record<string, any>),
                            ...(v as Record<string, any>)
                        }));
                    }

                    return createProxy(rootValue$$, path);
                };
            }

            return createProxy(rootValue$$, [...path, prop]);
        },

        apply() {
            return getFromPath(rootValue$$(), path);
        }

    }) as unknown as SignalTree<T>;
}